import { enhancedApi } from '@store/generated/templates';

/**
 * Note-template catalog API (GDN-2482).
 *
 * The catalog endpoints (`…/catalog-bootstrap` read + `…/batch-archive` mutate)
 * are part of the generated OpenAPI client now that the paired backend branch
 * ships them, so we enhance the CODEGEN endpoints rather than hand-inject. The
 * only thing added here is cache tags — codegen emits none.
 *
 * The batch mutation invalidates the note-template caches other features
 * provide (charting picker, org list, library) plus the encounter-type list
 * (types reference `template_id`) so pickers refresh after an archive /
 * de-adopt. The bootstrap read is deliberately left untagged — the catalog owns
 * its refresh with an awaited refetch (fresh rows before the verb resolves).
 */
const TEMPLATE_CATALOG_TAG_TYPES = [
  'Template',
  'TemplateList',
  'OrgTemplateList',
  'TemplateLibrary',
  'EncounterTypesList',
] as const;

export const templateCatalogApi = enhancedApi.enhanceEndpoints({
  addTagTypes: TEMPLATE_CATALOG_TAG_TYPES,
  endpoints: {
    postV2ProviderOrganizationsByOrgIdNoteTemplatesBatchArchive: {
      invalidatesTags: (
        _result,
        _error,
        { noteTemplateBatchArchiveRequest: req }
      ) => [
        { type: 'TemplateList', id: 'LIST' },
        { type: 'OrgTemplateList', id: 'LIST' },
        { type: 'TemplateLibrary', id: 'LIBRARY' },
        { type: 'EncounterTypesList', id: 'LIST' },
        ...[
          ...(req.archive_template_ids ?? []),
          ...(req.restore_template_ids ?? []),
        ].map((id) => ({ type: 'Template' as const, id })),
      ],
    },
  },
});

// User-friendly hook names — never export the verbose OpenAPI names into
// feature consumers (web-app CLAUDE.md).
export const {
  useGetV2ProviderOrganizationsByOrgIdNoteTemplatesCatalogBootstrapQuery:
    useGetTemplateCatalogBootstrapQuery,
  usePostV2ProviderOrganizationsByOrgIdNoteTemplatesBatchArchiveMutation:
    useBatchArchiveTemplatesMutation,
} = templateCatalogApi;
